import { UserRoleModel } from '@utmost.co/enterprise-models';

export enum EventSource {
  // Describes direct user action
  USER_INTERACTION = 'User Interaction',

  // Occurs as a result of indirect user action
  USER_EFFECT = 'User Effect',

  // An event triggered when the system is initializing
  SYSTEM_INIT = 'System Initialise',

  // Occurs when a server event is received
  SERVER_EVENT = 'Server Event',

  // Rendering
  VIEW_RENDER = 'View Render',

  // Page View
  PAGE_VIEW = 'Page View'
}

export enum InteractionType {
  CLICK = 'Click',
  SCROLL = 'Scroll',
  DRAG = 'Drag',
  DROP = 'Drop',
  HOVER = 'Hover',
  RIGHT_CLICK = 'Right Click',
  KEY_PRESS = 'Key Press',
  ZOOM_IN = 'Zoom In',
  ZOOM_OUT = 'Zoom Out',
  RESIZE = 'Resize',
  PAGE_VIEW = 'Page View',
  N_A = 'N/A'
}

export enum ComponentType {
  DATA_TABLE = 'Data Table',
  DATA_TABLE_CELL = 'Data Table Cell',
  DATA_TABLE_BULK_ACTION_BUTTON = 'Data Table Bulk Action Button',
  QUICK_REPORT_SETTINGS_BUTTON = 'Quick Report Settings Button',
  QUICK_REPORT_CHIP_EXPORT_BUTTON = 'Quick Report Chip Export Button',
  QUICK_REPORT = 'Quick Report',
  NOTIFICATION_ITEM = 'Notification Item',
  NOTIFICATION_BELL = 'Notification Bell',
  NOTIFICATION_MARK_ALL_READ_BUTTON = 'Notification Mark All Read',
  TASKS_ITEM = 'Tasks Item',
  TAB = 'Tab',
  OVERFLOW_MENU_OPEN_BUTTON = 'Overflow Menu Open Button',
  OVERFLOW_MENU_ITEM_BUTTON = 'Overflow Menu Item Button',
  SMARTFORM_EDIT_BUTTON = 'Smartform Edit Button',
  MAIN_MENU_BUTTON = 'Main Menu Button',
  // In the component scope
  PRIMARY_ACTION = 'Primary Action',
  // In the component scope
  SECONDARY_ACTION = 'Secondary Action',
  SUB_MENU_BUTTON = 'Sub Menu Button',
  HORIZONTAL_MENU_TAB = 'Horizontal Menu Tab',
  APP_TOOLBAR_BUTTON = 'App ToolBar Button',
  APP_BAR_AVATAR_BUTTON = 'App Bar Avatar Button',
  APP_BAR_AVATAR_MENU_ITEM = 'App Bar Avatar Menu Item',
  DIALOG = 'Dialog',
  DIALOG_CONFIRM_BUTTON = 'Dialog Confirm Button',
  DIALOG_CANCEL_BUTTON = 'Dialog Cancel Button',
  DIALOG_BUTTON = 'Dialog Button',
  TYPOGRAPHY_TOOLTIP = 'Typography Tooltip',
  MUI_SELECT = 'MUI Select',
  CLOSE_BUTTON = 'Close Button',
  OPEN_IN_NEW_TAB_BUTTON = 'Open In New Tab Button',
  DRAWER = 'Drawer',
  DRAWER_PRIMARY_ACTION_BUTTON = 'Drawer Primary Action Button',
  DRAWER_SECONDARY_ACTION_BUTTON = 'Drawer Secondary Action Button',
  SEARCH_INPUT = 'Search Input',
  EXPAND_BUTTON = 'Expand Button',
  EXPAND_COLLAPSE_ALL_BUTTON = 'Expand Collapse All Button',
  EDIT_BUTTON = 'Edit Button',
  ACCORDION_EXPAND_COLLAPSE_BUTTON = 'Accordion Expand/Collapse Button',
  INTERNAL_LINK_BUTTON = 'Internal Link Button',
  EXTERNAL_LINK_BUTTON = 'External Link Button',
  TOGGLE_BUTTON = 'Toggle Button',
  N_A = 'N/A'
}

export type AdditionalDetails = Record<string, string | boolean | number>;

export interface MixpanelEvent {
  eventDescription: string;
  eventKey: string;
  eventSource: EventSource;
  interactionType?: InteractionType;
  componentType?: ComponentType;
  distinct_id?: string;
  personUid?: string;
  customer?: string;
  envType?: string;
  userType?: UserRoleModel;
  details?: AdditionalDetails;
}
